<template>
  <div class="merit-box-item flex flex-align-top flex-justify-between">
    <div
      class="merit-item flex-1-base0 flex flex-v flex-align-center"
      v-for="(item, $index) in meritList"
      :key="$index"
    >
      <img class="merit-img" :src="item.img" alt="" />
      <div class="merit-name">{{ item.name }}</div>
      <div class="merit-desc" v-html="item.desc"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let meritList = Object.freeze([
      {
        name: '覆盖广泛',
        desc: '业务覆盖<br/>国内360座城市',
        img: require('../../assets/img/index/merit/ic_merit_1.png'),
      },
      {
        name: '同城/跨城',
        desc: '城市群之间的<br/>短途、长途货运',
        img: require('../../assets/img/index/merit/ic_merit_2.png'),
      },
      {
        name: '车型齐全',
        desc:
          '根据货量选择车型，<br/>平台涵盖小面包车到17.5米大货车等<br/>多种车型可选<br/>（以城市实际开通情况为准）',
        img: require('../../assets/img/index/merit/ic_merit_3.png'),
      },
      {
        name: '时效自主',
        desc: '即时/预约快速响应，<br/>订单发出平均30秒内司机接单<br/>计划型物流需求可提前预约',
        img: require('../../assets/img/index/merit/ic_merit_4.png'),
      },
      {
        name: '业务模式灵活',
        desc: '根据合作方业务需求，<br/>选择配置API应用，<br/>适应多元化物流场景',
        img: require('../../assets/img/index/merit/ic_merit_5.png'),
      },
    ]);
    return {
      meritList,
    };
  },
};
</script>

<style lang="scss" scoped>
.merit-box-item {
  padding: 80px 20px;
}
.merit-item {
  text-align: center;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  .merit-img {
    width: 96px;
    height: 90px;
    vertical-align: top;
  }
  .merit-name {
    margin-top: 34px;
    color: #393939;
    font-size: 18px;
    font-weight: bold;
  }
  .merit-desc {
    margin-top: 22px;
    color: #000;
    font-size: 12px;
    line-height: 22px;
  }
  &:hover {
    transform: scale(1.2);

    .merit-name {
      color: #f16622;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/merit.vue